import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedStories() {
  const featured = articles.filter(a => a.featured);
  const rest = articles.filter(a => !a.featured).slice(0, 3);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Featured Stories <span className="text-accent-500" role="img" aria-label="sparkle">✦</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {featured.map((article, i) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className={`group relative rounded-lg overflow-hidden cursor-pointer ${
                i === 0 ? 'md:col-span-1 md:row-span-2' : ''
              }`}
              style={{ minHeight: i === 0 ? '440px' : '280px' }}
            >
              <img
                src={article.imageUrl}
                alt={article.title}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                title={`${article.title} - The Vertex`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-500/20 backdrop-blur-sm text-background-50 text-[10px] md:text-xs font-label font-medium tracking-wide uppercase mb-2 md:mb-3">
                  {article.category}
                </span>
                <h3 className="text-base md:text-lg font-heading font-semibold text-background-50 leading-snug mb-1.5 md:mb-2 group-hover:text-background-50/90 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-background-50/60 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2.5 mt-3 text-[10px] md:text-xs text-background-50/50">
                  <span className="font-medium text-background-50/80">{article.author}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}

          {rest.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group relative rounded-lg overflow-hidden cursor-pointer"
              style={{ minHeight: '280px' }}
            >
              <img
                src={article.imageUrl}
                alt={article.title}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                title={`${article.title} - The Vertex`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-500/20 backdrop-blur-sm text-background-50 text-[10px] md:text-xs font-label font-medium tracking-wide uppercase mb-2 md:mb-3">
                  {article.category}
                </span>
                <h3 className="text-base md:text-lg font-heading font-semibold text-background-50 leading-snug mb-1.5 md:mb-2 group-hover:text-background-50/90 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-background-50/60 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2.5 mt-3 text-[10px] md:text-xs text-background-50/50">
                  <span className="font-medium text-background-50/80">{article.author}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}